import { Component } from "react";
import AuthService from "services/auth.service";

const currentUser = AuthService.getCurrentUser();

export class DocereeBannerSection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show_banner: 'show-banner'
    };
  }

  closeBanner(){
    this.setState({
      show_banner: 'hide-banner'
    });
  }
  render() {
    const docereeBannerStyleBottom = {
      minHeight: '1px', 
      width: '728px', 
      height: '90px',
      border: '1px solid black',
      background: 'white'
    }
    const topBannerStyle = {
      position: 'fixed',
      zIndex: '999',
      left: '50%',
      top: '0',
      transform: 'translate(-50%, 0%)'
    }
    const bannerCloseBtnStyle = {
      padding: '1px 10px',
      fontSize: '14px',
      background: 'white',
      borderRadius: '0',
      border: '1px solid gray',
      color: '#F25C54',
      marginTop: '-3px'
    }

    if (currentUser && currentUser.user_type === 'doctor'){ return (
      <div className={'top-banner-container '+this.state.show_banner} style={topBannerStyle}>
        <div id={process.env.REACT_APP_DOCEREE_AD_ID} className="datag" style={docereeBannerStyleBottom}></div>
        <button className="btn" style={bannerCloseBtnStyle} onClick={this.closeBanner.bind(this)}>close</button>
      </div>
    )}else return <></>;
  }
}